import {useState} from "react";

import {
signInWithEmailAndPassword
} from "firebase/auth";

import {
auth
} from "../firebase";

import {
useNavigate
} from "react-router-dom";


function AdminLogin(){


const [email,setEmail]=useState("");

const [password,setPassword]=useState("");

const navigate=useNavigate();



const login=async(e)=>{

e.preventDefault();


try{


await signInWithEmailAndPassword(
auth,
email,
password
);


navigate("/admin");


}

catch(error){

alert("بيانات الدخول خاطئة");

}


};



return(

<div className="admin-login-page">


<div className="admin-login-box">


<h1>
Admin Login 
</h1>



<input

placeholder="Email"

onChange={(e)=>setEmail(e.target.value)}

/>



<input

type="password"

placeholder="Password"

onChange={(e)=>setPassword(e.target.value)}

/>



<button onClick={login}>

Login

</button>



</div>


</div>

)
}

export default AdminLogin;